const entersViewport = function (elem, offset = 0) {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= offset &&
        bounding.top <=
        (window.innerHeight - offset || document.documentElement.clientHeight - offset)
    );
};

export default entersViewport;